import type { CalendarEvent } from '../../types/db';

export const calendar: CalendarEvent[] = [
  { id: 'e-standup', start: '10:00', end: '10:15', title: 'Stand-up project X', kind: 'overleg' },
  { id: 'e-focus-1', start: '10:30', end: '12:30', title: 'Focusblok', kind: 'focus' },
  {
    id: 'e-lisa',
    start: '14:00',
    end: '15:00',
    title: 'Meeting met Lisa, nieuwe klant',
    kind: 'meeting',
    contactId: 'lisa',
    location: 'Studio Veld, Utrecht',
    travelMinutes: 25,
  },
  { id: 'e-focus-2', start: '16:30', end: '18:00', title: 'Focusblok', kind: 'focus' },
];
